---
nb:
  admin:
    production_periods:
      errors:
        generic: Kunne ikke laste data for produksjonsperioder.
      filters:
        date: Dato
        month: Måned
        power_plant: Kraftverk
        week_start: Ukestart
        year: År
      labels:
        data_horizon: Datagrense
        power_plant: Kraftverk
        settled_source: 'Avregnet: {source}'
        sources: Kilder
        timezone: Tidssone
        unknown: Ukjent
        unsettled_source: 'Uavregnet: {source}'
      missing_segments:
        empty: Ingen manglende segmenter for den valgte visningen.
        hours_missing:
          one: "{count} time mangler"
          other: "{count} timer mangler"
        title: Manglende segmenter
      summary:
        missing_unknown: Ingen dekningsinformasjon tilgjengelig.
        settled_hours_label: Avregnede timer til stede
        settled_volume_label: Avregnet volum (MWh)
        unsettled_hours_label: Uavregnede timer til stede
        unsettled_volume_label: Uavregnet volum (MWh)
      table:
        hour: Time
        no_day_data: Ingen timeverdier
        no_timeline_data: Ingen tidslinjedata
        selected_series_mwh: Valgt serie (MWh)
        settled_mwh: Avregnet (MWh)
        unsettled_mwh: Uavregnet (MWh)
      timeline:
        coverage: Dekning
        label: Dato
        missing_hours: Manglende timer
        settled_coverage: Avregnet dekning
        settled_hours: Avregnede timer
        settled_volume: Avregnet (MWh)
        unsettled_coverage: Uavregnet dekning
        unsettled_hours: Uavregnede timer
        unsettled_volume: Uavregnet (MWh)
      title: Produksjonsperioder
